module.exports = __webpack_public_path__ + "static/media/menu-arrow.33c22428.svg";